import { apiClient } from "../apiClient";

export const XEP_HANG_TOT_NGHIEP_ENDPOINT = "xep-hang-tot-nghiep";
export const xepHangTotNghiepApi = {
    SelectAll: () => apiClient.get(`${XEP_HANG_TOT_NGHIEP_ENDPOINT}`),
    Insert: (payload: any) => apiClient.post(`${XEP_HANG_TOT_NGHIEP_ENDPOINT}`, payload),
    Update: (id: number, payload: any) => apiClient.put(`${XEP_HANG_TOT_NGHIEP_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${XEP_HANG_TOT_NGHIEP_ENDPOINT}/${id}`)
};